import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "19", y2: "5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "5 12 12 5 19 12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUp";
const ArrowUp = memo(themed(Icon));
export {
  ArrowUp
};
//# sourceMappingURL=arrow-up.js.map
